import React from "react";

import { ChoiceUI } from "../UI";

/**
 * Bara de taburi din popup-urile de profil (elev, instructor, personal): tiparul ChoiceUI
 * look="tabs" cu iconițe — 44px, filele închise doar cu iconița, fila deschisă se lățește cu
 * textul sub iconiță (scss/UI/_choiceUI.scss, --stacked). items: [{ key, label, icon, badge? }]
 */
export default function ProfileTabs({
   items = [],
   value,
   onChange,
   className = "",
   "aria-label": ariaLabel = "Secțiuni profil",
}) {
   const list = Array.isArray(items) ? items.filter(Boolean) : [];
   if (!list.length) return null;

   return (
      <ChoiceUI
         look="tabs"
         aria-label={ariaLabel}
         value={value}
         onChange={onChange}
         className={"profileTabs" + (className ? ` ${className}` : "")}
         options={list.map((item) => {
            const badge = Number(item.badge) || 0;
            return {
               value: item.key,
               label: item.label,
               icon: item.icon,
               title: item.label,
               count: badge > 0 ? (badge > 99 ? "99+" : badge) : undefined,
            };
         })}
      />
   );
}
